<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-招聘信息-添加
      修改：职位类型改为多级树状显示
    -->
    <el-dialog
    title="添加招聘信息"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加招聘信息</div>
    <!-- 全分类选择 -->
    <!-- <el-form-item label="选择全分类" prop="name" >
          <div>{{ form.categorya.name }}</div>
      
        <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为招聘信息标题</el-button>
      </el-form-item> -->

      <el-form-item label="招聘信息名称" prop="name"><el-input v-model="form.name" placeholder="请输入招聘信息名称" class="max-w460"></el-input></el-form-item>
      <el-form-item label="招聘信息bannar：" prop="model.bannar">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.bannar">
          <transition-group>
            <div v-for="(item, index) in form.bannar" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('bannar')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
     <el-form-item label="薪资" prop="min_salary">
              <el-input-number 
                v-model="form.daily_salary" 
                :min="0" 
                :step="1000" 
                controls-position="right"
                class="max-w460"
              />
            </el-form-item>
                <el-form-item label="用工天数" prop="max_salary">
              <el-input-number 
                v-model="form.work_days" 
                :min="1" 
                :step="1000" 
                controls-position="right"
                class="max-w460"
              />
            </el-form-item>
                <el-form-item label="需求人数" prop="max_salary">
              <el-input-number 
                v-model="form.required_number" 
                :min="1" 
                :step="1000" 
                controls-position="right"
                class="max-w460"
              />
            </el-form-item>

                              <!-- 新增虚拟申请人数 -->

      <el-form-item label="虚拟申请人数" prop="virtual_required_number">
          <el-input 
            v-model="form.virtual_required_number" 
            placeholder="请输入虚拟申请人数" 
            class="max-w460"
          />
        </el-form-item>

              <el-form-item label="公司名称" prop="company_name">
          <el-input 
            v-model="form.company_name" 
            placeholder="请输入公司名称" 
            class="max-w460"
          />
        </el-form-item>

           <el-form-item label="工作地点" prop="work_location">
              <el-input 
                v-model="form.work_location" 
                placeholder="请输入工作地点" 
                class="max-w460"
              />
            </el-form-item>

             <el-form-item label="所在城市" prop="work_city">
              <el-input 
                v-model="form.work_city" 
                placeholder="请输入所在城市" 
                class="max-w460"
              />
            </el-form-item>

            <el-form-item label="经验要求" prop="experience_required">
              <el-select 
                v-model="form.experience_required" 
                placeholder="请选择经验要求"
                class="max-w460"
                clearable
              >
                <el-option
                  v-for="item in experienceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

             <el-form-item label="学历要求" prop="education_required">
              <el-select 
                v-model="form.education_required" 
                placeholder="请选择学历要求"
                class="max-w460"
                clearable
              >
                <el-option
                  v-for="item in educationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

             <!-- 职位类型：多级树状显示 -->
        <el-form-item label="职位类型" prop="job_type">
          <el-cascader
            v-model="form.job_type"
            :options="jobTypeTree"
            :props="{ value: 'name', label: 'name', children: 'children', checkStrictly: false }"
            placeholder="请选择职位类型"
            class="max-w460"
            clearable
            filterable
            @change="handleJobTypeChange"
          />
        </el-form-item>

        <el-form-item label="联系方式" prop="hr_contact">
          <el-input 
            v-model="form.hr_contact" 
            placeholder="请输入联系方式" 
            class="max-w460"
          />
        </el-form-item>

        <el-form-item label="招聘信息介绍" prop="intro">
          <div class="edit_container">
            <Uediter 
              v-model="form.intro" 
              :text="ueditor.text" 
              :config="ueditor.config" 
              ref="ue"
            />
          </div>
        </el-form-item>

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import Recruitment_infoApi from '@/api/recruitment_info.js';
import Employment_typeApi from '@/api/employment_type.js'; 
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        bannar:[],
        max_salary:0,
        virtual_required_number:0,
        min_salary:0,
        company_name:'',
        required_number:0,
        work_days:0,
        daily_salary:0,
        work_location:'',
        work_city:'',
        experience_required:'',
        education_required:'',
        job_type:'',      // 存储选中的职位类型（完整路径数组或最终值）
        hr_contact:'',
        edit_container:'',
        

      },
       experienceOptions: [
      { value: '不限', label: '不限' },
      { value: '应届毕业生', label: '应届毕业生' },
      { value: '1年以下', label: '1年以下' },
      { value: '1-3年', label: '1-3年' },
      { value: '3-5年', label: '3-5年' },
      { value: '5-10年', label: '5-10年' },
      { value: '10年以上', label: '10年以上' }
    ],
    educationOptions: [
      { value: '不限', label: '不限' },
      { value: '高中及以上', label: '高中及以上' },
      { value: '大专及以上', label: '大专及以上' },
      { value: '本科及以上', label: '本科及以上' },
      { value: '硕士及以上', label: '硕士及以上' },
      { value: '博士及以上', label: '博士及以上' }
    ],
    jobTypeList: [],      // 原始扁平数据或列表
    jobTypeTree: [],      // 转换后的树状结构数据
    // jobTypeOptions: [
    //   { value: '全职', label: '全职' },
    //   { value: '兼职', label: '兼职' },
    //   { value: '实习', label: '实习' },
    //   { value: '临时', label: '临时' },
    //   { value: '远程', label: '远程' }
    // ],
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          { required: true, message: '请输入招聘信息名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur' }
        ],
        company_name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        min_salary: [
          { required: true, message: '请输入最低薪资', trigger: 'blur' }
        ],
        max_salary: [
          { required: true, message: '请输入最高薪资', trigger: 'blur' },
        ],
        experience_required: [
          { required: true, message: '请选择经验要求', trigger: 'change' }
        ],
        education_required: [
          { required: true, message: '请选择学历要求', trigger: 'change' }
        ],
        job_type: [
          { required: true, message: '请选择职位类型', trigger: 'change' }
        ],
        hr_contact: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ]
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getJobTypeList();
  },
  props: ["open_add"],
  methods: {
  getJobTypeList() {
        Employment_typeApi.getJobTypes({}, true).then(data => {
          this.jobTypeList = data.data.list;
          // 将扁平列表转换为树状结构
          this.jobTypeTree = this.buildTree(this.jobTypeList);
        }).catch(error => {
          console.error('获取职位类型失败', error);
        });
      },
    // 将扁平数据转换为树状结构的方法
    buildTree(list) {
      if (!list || list.length === 0) return [];
      // 假设每个节点有 id, parent_id, name 字段（根据实际API调整）
      // 如果接口返回的数据结构不同，请修改这里的映射关系
      const map = {};
      const roots = [];
      
      // 先创建所有节点的映射
      list.forEach(item => {
        map[item.employment_type_id] = { 
          ...item, 
          children: [],
          name: item.name,      // 用于显示
          value: item.name      // 用于选中值
        };
      });
      
      // 构建父子关系
      list.forEach(item => {
        const node = map[item.employment_type_id];
        if (item.parent_id && map[item.parent_id]) {
          // 有父节点，添加到父节点的children中
          map[item.parent_id].children.push(node);
        } else {
          // 没有父节点或父节点不存在，作为根节点
          roots.push(node);
        }
      });
      
      // 递归清理空children
      const cleanEmptyChildren = (nodes) => {
        nodes.forEach(node => {
          if (node.children && node.children.length === 0) {
            delete node.children;
          } else if (node.children && node.children.length > 0) {
            cleanEmptyChildren(node.children);
          }
        });
        return nodes;
      };
      
      return cleanEmptyChildren(roots);
    },
    // 职位类型变化时的处理
    handleJobTypeChange(value) {
      // value 是选中的路径数组，例如 ['技术', '后端开发', 'Java']
      // 如果需要保存最终选中的名称，可以取最后一个
      if (value && value.length > 0) {
        this.form.job_type = value[value.length - 1];
      } else {
        this.form.job_type = '';
      }
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Recruitment_infoApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/recruitment_info/index/part/add.vue